import { render, staticRenderFns } from "./basic-container.vue?vue&type=template&id=17414ad5"
import script from "./basic-container.vue?vue&type=script&lang=js"
export * from "./basic-container.vue?vue&type=script&lang=js"
import style0 from "./basic-container.vue?vue&type=style&index=0&id=17414ad5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17414ad5')) {
      api.createRecord('17414ad5', component.options)
    } else {
      api.reload('17414ad5', component.options)
    }
    module.hot.accept("./basic-container.vue?vue&type=template&id=17414ad5", function () {
      api.rerender('17414ad5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic-container/basic-container.vue"
export default component.exports